import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UseBillingPaymentCancel {
  paymentId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingPaymentCancel = ({ paymentId, onSuccess, onError }: UseBillingPaymentCancel) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingPaymentCancel', paymentId],
    mutationFn: () => privateAxios.put(`/billing/payments/${paymentId}/cancel`),
    onSuccess,
    onError,
  });
};
